export default function CelebrantTermsOfService() {
  return (
    <div className="prose prose-lg max-w-none">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service - Wedding Celebrants</h1>
      
      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Acceptance of Terms</h2>
          <p className="text-gray-700 leading-relaxed">
            By registering as a wedding celebrant on PhilTrade, you agree to be bound by these Terms of Service. 
            These terms govern your use of our platform and participation in wedding supplier exhibits.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Platform Usage</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-medium text-gray-700">2.1 Account Registration</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Provide accurate and current information during registration</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized account access</li>
              <li>You may only maintain one account per person</li>
            </ul>

            <h3 className="text-lg font-medium text-gray-700">2.2 Exhibit Attendance</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Respect exhibit rules and venue guidelines</li>
              <li>Behave professionally when interacting with suppliers</li>
              <li>Follow all safety and security protocols</li>
              <li>Respect other attendees and their privacy</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Service Bookings</h2>
          <div className="space-y-3">
            <p className="text-gray-700 leading-relaxed">
              When booking services through PhilTrade or at our exhibits, you understand that:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>All service agreements are directly between you and the supplier</li>
              <li>PhilTrade facilitates connections but is not a party to service contracts</li>
              <li>You are responsible for reviewing and understanding service terms</li>
              <li>Payment and service delivery are handled directly with suppliers</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Privacy and Data</h2>
          <p className="text-gray-700 leading-relaxed">
            Your privacy is important to us. We collect and use your information in accordance with our 
            Privacy Policy. By using our platform, you consent to the collection and use of your data 
            as described in our privacy policy.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Prohibited Activities</h2>
          <div className="space-y-3">
            <p className="text-gray-700 leading-relaxed">
              You agree not to engage in the following activities:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Harassment or inappropriate behavior toward suppliers or other attendees</li>
              <li>Sharing false or misleading information</li>
              <li>Attempting to circumvent platform security measures</li>
              <li>Using the platform for illegal or unauthorized purposes</li>
              <li>Spamming or sending unsolicited communications</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Intellectual Property</h2>
          <p className="text-gray-700 leading-relaxed">
            You retain ownership of any content you share on our platform. By posting content, 
            you grant PhilTrade a license to display and use your content for platform operations 
            and promotional purposes.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Dispute Resolution</h2>
          <p className="text-gray-700 leading-relaxed">
            Any disputes between you and suppliers should be resolved directly with the supplier. 
            PhilTrade is not responsible for mediating disputes or providing refunds for services 
            booked through our platform.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Platform Availability</h2>
          <p className="text-gray-700 leading-relaxed">
            While we strive to maintain platform availability, we cannot guarantee uninterrupted access. 
            We reserve the right to modify, suspend, or discontinue any part of our service at any time.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Limitation of Liability</h2>
          <p className="text-gray-700 leading-relaxed">
            PhilTrade is not liable for any damages arising from your use of our platform, 
            interactions with suppliers, or services booked through our platform. You use our 
            service at your own risk.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Contact Information</h2>
          <p className="text-gray-700 leading-relaxed">
            For questions about these terms or your account, please contact us at 
            <a href="mailto:support@philtrade.com" className="text-orange-600 hover:text-orange-700">
              support@philtrade.com
            </a>
          </p>
        </section>
      </div>
    </div>
  )
}
